import { BrandSettingsProvider } from "../brand-settings";
import { SDKConfiguration } from "@/inference/setup/config";
import { FBPixelSDK } from "./plugs/fbpixel";
import { GtagSDK } from "./plugs/gtag";

export class RetargetingPlugsProvider {
  static async init(): Promise<void> {
    const settings = BrandSettingsProvider.getSettings();
    const isEnabled =
      BrandSettingsProvider.isFeatureEnabled("retargetingPlugs");

    if (!isEnabled) return;

    const retargetingDetails = settings?.featureFlags.retargetingPlugs?.details;

    if (retargetingDetails?.fbpixel) {
      this.initWithRetry(window, "fbq", () => {
        FBPixelSDK.init();
      });
    }

    if (retargetingDetails?.gtag) {
      this.initWithRetry(window, "gtag", () => {
        GtagSDK.init();
      });
    }
  }

  private static initWithRetry(
    context: any,
    propertyName: string,
    initFunction: () => void,
  ): void {
    if (context[propertyName]) {
      initFunction();
    } else {
      const id = setInterval(() => {
        if (context[propertyName]) {
          initFunction();
          clearInterval(id);
        }
      }, 1_000);
    }
  }

  static async track(
    eventName: string,
    eventProperties: Record<string, any>,
  ): void {
    try {
      if (!window?.webengage?.track) {
        throw new Error("WebEngage track function is unavailable.");
      }
      window.webengage.track(eventName, eventProperties);
    } catch (error) {
      console.error("Error tracking event:", eventName, error);
    }
  }

  static async setUserAttribute(key: string, value: any): void {
    try {
      if (!window?.webengage?.user?.setAttribute) {
        throw new Error("WebEngage setAttribute function is unavailable.");
      }
      window.webengage.user.setAttribute(key, value);
    } catch (error) {
      console.error(`Error setting user attribute: ${key} -`, error);
    }
  }

  static flushEvents(payload: any): void {
    // const settings = BrandSettingsProvider.getSettings();
    // const isEnabled =
    //   BrandSettingsProvider.isFeatureEnabled("retargetingPlugs");
    // if (!isEnabled) return;
    // const retargetingDetails = settings?.featureFlags.retargetingPlugs?.details;
    // FBPixelSDK.flush(payload);
    // if (retargetingDetails?.fbpixel) {
    // }
    // GtagSDK.flush(payload);
    // if (retargetingDetails?.gtag) {
    // }
  }
}
